import { render } from "./HighLights.vue?vue&type=template&id=50d242d1&scoped=true"
import script from "./HighLights.vue?vue&type=script&lang=js"
export * from "./HighLights.vue?vue&type=script&lang=js"

import "./HighLights.vue?vue&type=style&index=0&id=50d242d1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50d242d1"]])

export default __exports__